import ChunkUploader from './ChunkUploader'

export function deleteTempImages(responseObjCollection, token){
    const uploader = new ChunkUploader()
    const dirs = responseObjCollection.map(obj => {
        return obj.dirName
    })
    return uploader.deleteTempImages(dirs, token)
}



// WEBPACK FOOTER //
// ./src/utils/uploadHelpers.js